/*
 * (C) Copyright HCL Technologies Ltd. 2019
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
define([], function() {
	return function(ldr, name, req, async) {
		var resolveFn, result, resultSet;
		ldr.load(name,  req, function(data) {
			result = data;
			resultSet = true;
			if (resolveFn) {
				resolveFn(data);
			}
		}, {isBuild:true});
		if (resultSet) {
			return result;
		} else if (!async) {
			throw new Error(name + ' unavailable');
		}
		result = new Promise(function(resolve) {
			resolveFn = resolve;
		});
		result.__DOJO_WEBPACK_DEFINE_PROMISE__ = true;
		return result;
	};
});
